import React from 'react';
import { Box, Select, MenuItem, SelectChangeEvent, FormControl } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import ActionMenu from 'components/_atoms/ActionMenu';
import { MOCK_MANUALS } from '../_constants';

interface OrganizationalTrendsFiltersProps {
  selectedManual: string;
  onManualChange: (event: SelectChangeEvent<string>) => void;
  onReportSelect: (reportType: string) => void;
}

export default function OrganizationalTrendsFilters({
  selectedManual,
  onManualChange,
  onReportSelect,
}: OrganizationalTrendsFiltersProps) {
  const reportMenuItems = [
    {
      key: 'memberPerformance',
      label: t('dashboard.riskPool.riskPoolOrg.reports.memberPerformance'),
      onClick: () => onReportSelect('memberPerformance'),
    },
    {
      key: 'memberPolicyAudit',
      label: t('dashboard.riskPool.riskPoolOrg.reports.memberPolicyAudit'),
      onClick: () => onReportSelect('memberPolicyAudit'),
    },
    {
      key: 'agencyPolicyMetrics',
      label: t('dashboard.riskPool.riskPoolOrg.reports.agencyPolicyMetrics'),
      onClick: () => onReportSelect('agencyPolicyMetrics'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
      }}
    >
      {/* Manual Dropdown */}
      <FormControl sx={{ p: 0 }}>
        <Select
          value={selectedManual}
          onChange={onManualChange}
          displayEmpty
          sx={{
            minWidth: 150,
            backgroundColor: 'white',
            height: 36.5,
            '& .MuiSelect-select': {
              py: 0.75,
            },
          }}
        >
          {MOCK_MANUALS.map((manual) => (
            <MenuItem
              key={manual.id}
              value={manual.id}
            >
              {manual.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Reports Button
      <ActionMenu
        id='reports-menu'
        btnText={t('dashboard.riskPool.riskPoolOrg.filters.reports')}
        items={reportMenuItems}
        btnProps={{
          size: 'small',
        }}
        anchorOrigin='left'
      /> */}
    </Box>
  );
}
